import React, { useEffect, useState } from "react";
import axios from "axios";
import "../index.css";

const TodayBookings = () => {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const bookingsPerPage = 5;

  useEffect(() => {
    fetchBookings();
  }, []);

  const fetchBookings = () => {
    axios
      .get(`${process.env.REACT_APP_BACKEND}/api/rides/today-bookings`)
      .then((response) => {
        setBookings(response.data);
        setLoading(false);
      })
      .catch(() => {
        setError("Failed to fetch today's bookings");
        setLoading(false);
      });
  };

  const filteredBookings = bookings.filter((booking) => {
    const fullName = `${booking.firstName} ${booking.lastName}`.toLowerCase();
    return (
      fullName.includes(searchTerm.toLowerCase()) ||
      booking.serviceType.toLowerCase().includes(searchTerm.toLowerCase()) ||
      booking.pickupLocation.toLowerCase().includes(searchTerm.toLowerCase()) ||
      booking.dropoffLocation.toLowerCase().includes(searchTerm.toLowerCase()) ||
      booking.phoneNumber.toLowerCase().includes(searchTerm.toLowerCase()) ||
      booking.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
      booking.vehicle.toLowerCase().includes(searchTerm.toLowerCase())
    );
  });

  const indexOfLastBooking = currentPage * bookingsPerPage;
  const indexOfFirstBooking = indexOfLastBooking - bookingsPerPage;
  const currentBookings = filteredBookings.slice(indexOfFirstBooking, indexOfLastBooking);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(filteredBookings.length / bookingsPerPage); i++) {
    pageNumbers.push(i);
  }

  if (loading) return <p>Loading bookings...</p>;
  if (error) return <p>{error}</p>;

  return (
    <div className="today-bookings-container container mt-4">
      <h2 className="today-bookings-title text-center mb-4">Today's Bookings</h2>

      {/* Search Bar */}
      <div className="mb-3">
        <input
          type="text"
          className="today-bookings-search form-control"
          placeholder="Search bookings..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <div className="table-responsive">
        <table className="today-bookings-table table table-striped table-bordered">
          <thead className="today-bookings-table-head">
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Service Type</th>
              <th>Pickup Date</th>
              <th>Pickup Time</th>
              <th>Pickup Location</th>
              <th>Dropoff Location</th>
              <th>Passengers</th>
              <th>Luggage</th>
              <th>Child Seats</th>
              <th>Vehicle</th>
              <th>Phone Number</th>
              <th>Email</th>
            </tr>
          </thead>
          <tbody>
            {currentBookings.map((booking, index) => (
              <tr key={booking._id}>
                <td>{indexOfFirstBooking + index + 1}</td>
                <td>{booking.firstName} {booking.lastName}</td>
                <td>{booking.serviceType}</td>
                <td>{booking.pickupDate}</td>
                <td>{booking.pickupTime}</td>
                <td>{booking.pickupLocation}</td>
                <td>{booking.dropoffLocation}</td>
                <td>{booking.passengers}</td>
                <td>{booking.luggage}</td>
                <td>
                  {Array.isArray(booking.childSeats) ? (
                    booking.childSeats.map((seat, i) => (
                      <div key={i}>
                        {seat.type} (Luggage: {seat.luggage})
                      </div>
                    ))
                  ) : (
                    "No child seats"
                  )}
                </td>
                <td>{booking.vehicle}</td>
                <td>{booking.phoneNumber}</td>
                <td>{booking.email}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <nav>
        <ul className="pagination justify-content-center">
          {pageNumbers.map((number) => (
            <li key={number} className={`page-item ${currentPage === number ? "active" : ""}`}>
              <button onClick={() => paginate(number)} className="page-link">
                {number}
              </button>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
};

export default TodayBookings;
